import { RolesPlayerType } from "../types";

export const ItemsMenuHorizontal = {
  tabs: [
    {
      label: "",
      id: "home",
    },
    {
      label: "",
      id: "direct",
    },
    {
      label: "",
      id: "group",
    },
  ],
  initialTabId: "home",
};

export const LIMIT_SUGGESTION = 4;

export const suggestionList = [
  "suggestion-people",
  // "suggestion-channels",
  "suggestion-groups",
];

export const conversationTypeList = ["direct", "channel", "group"];

export const groupChannelTypeList = ["channel", "group"];

export const OwnerAdminRoleList = ["owner", "admin"];

export const RolesPlayer: RolesPlayerType[] = ["owner", "admin", "member"];

export const CreateUpdatePublicValues = {
  1: "Public",
  0: "Private",
};

export const PATHNAME_IS_NOT_VALID = ["/arena"];
